import { Phone, Shield, Star } from "lucide-react";
import { SITE } from "@/lib/siteConfig";

/**
 * SeoContent: bloc de texte SEO générique (sans référence géographique).
 * Si serviceName est passé, le texte est adapté au service.
 */
export default function SeoContent({ serviceName = null }) {
  return (
    <section data-testid="seo-content" className="bg-[#F3F4F6] py-16 sm:py-20 reveal">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white border-l-4 border-red-600 p-8 sm:p-12">
          <div className="text-xs tracking-[0.25em] uppercase font-bold text-red-600 mb-4">
            — {serviceName ? `${serviceName} · Serrurier d'urgence` : `Serrurier d'urgence 24h/24`}
          </div>
          <h2 className="font-display font-black tracking-tighter text-3xl sm:text-4xl uppercase leading-[0.95] text-[#0A0A0A] mb-6">
            {serviceName
              ? `${serviceName} : votre serrurier de proximité, 24h/24.`
              : `Votre serrurier d'urgence, à toute heure.`}
          </h2>

          <div className="space-y-5 text-slate-600 text-base sm:text-[17px] leading-relaxed">
            <p>
              {serviceName ? (
                <>
                  Vous recherchez un <strong>serrurier professionnel</strong> pour{" "}
                  {serviceName.toLowerCase()} ? <strong>SOS Serrurier Express</strong> intervient
                  24 heures sur 24, 7 jours sur 7, avec une équipe de techniciens
                  qualifiés. Que ce soit pour une urgence, un dépannage ou une installation prévue,
                  nous garantissons une intervention rapide, propre et au juste prix.
                </>
              ) : (
                <>
                  À la recherche d'un <strong>serrurier d'urgence</strong> ? Notre équipe
                  intervient en moins de 30 minutes pour tout type de
                  dépannage : porte claquée, clé perdue, serrure forcée, blindage de porte ou
                  ouverture de coffre-fort. Nos techniciens travaillent avec du matériel certifié
                  A2P et appliquent une grille tarifaire transparente, communiquée par téléphone
                  avant tout déplacement.
                </>
              )}
            </p>

            <p>
              <strong className="text-[#0A0A0A]">Pourquoi choisir SOS Serrurier Express ?</strong>{" "}
              La rapidité et la transparence font notre différence. Nos équipes sont mobilisées
              en permanence pour intervenir à toute heure, y compris la nuit et les week-ends.
              Nous maîtrisons tous les types de serrures (3 points, 5 points, multipoints,
              A2P étoiles) ainsi que les spécificités des immeubles anciens et neufs.
            </p>

            <p>
              <strong className="text-[#0A0A0A]">Notre engagement.</strong> Avant chaque
              intervention, un devis clair vous est communiqué oralement par téléphone, puis confirmé
              par écrit sur place. Aucun frais caché, aucune majoration nocturne abusive, aucun
              remplacement de pièce sans votre accord. Nous fournissons systématiquement une facture
              détaillée, conforme aux exigences des compagnies d'assurance, ainsi qu'une garantie
              de deux ans sur les pièces et la main-d'œuvre.
            </p>
          </div>

          <div className="mt-8 grid sm:grid-cols-3 gap-3 text-sm">
            {[
              { ic: Phone, t: `Joignable 24h/24 · 7j/7` },
              { ic: Shield, t: "Matériel certifié A2P" },
              { ic: Star, t: "4,9/5 sur 1 200+ avis" },
            ].map((b, i) => {
              const Ic = b.ic;
              return (
                <div key={i} className="flex items-center gap-2 bg-[#F3F4F6] px-3 py-2.5">
                  <Ic className="w-4 h-4 text-red-600 flex-shrink-0" strokeWidth={2.5} />
                  <span className="font-bold text-slate-700">{b.t}</span>
                </div>
              );
            })}
          </div>

          <a
            href={SITE.phoneHref}
            data-testid="seo-call"
            className="mt-8 inline-flex items-center gap-3 bg-red-600 hover:bg-red-700 text-white px-6 py-4 font-display font-bold uppercase tracking-tight transition-all"
          >
            <Phone className="w-5 h-5" strokeWidth={2.5} />
            Appeler {SITE.phone}
          </a>
        </div>
      </div>
    </section>
  );
}
